'use client'

import { useMemo, useRef } from 'react'
import { InView } from 'react-intersection-observer'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getItemsByName,
  transformItemsBlockItemDtoToProductItem,
} from '@marketplace-web/item-page/item-page-data'

import ItemViewItems from '../../components/ItemViewItems/ItemViewItems'
import { ItemPageClosetPluginModel } from './types'
import ItemsGridSkeleton from '../../components/ItemsGridSkeleton'

type Props = {
  data: ItemPageClosetPluginModel
}

const ItemPageClosetPlugin = ({ data }: Props) => {
  const { itemId } = data

  const { fetch: fetchClosetItems, data: closetItemsData, isLoading } = useFetch(getItemsByName)
  const hasFetched = useRef(false)

  const userItems = useMemo(() => {
    return closetItemsData?.items.filter(item => item.id !== itemId) || []
  }, [closetItemsData, itemId])

  const onInViewChange = (inView: boolean) => {
    if (!inView || hasFetched.current) return

    fetchClosetItems({
      itemId: itemId.toString(),
      name: 'other_user_items',
    })
    hasFetched.current = true
  }

  return (
    <InView as="div" data-testid="item-page-closet-plugin" onChange={onInViewChange}>
      {(!closetItemsData || isLoading) && <ItemsGridSkeleton />}
      {userItems?.length > 0 && (
        <ItemViewItems
          items={userItems.map(transformItemsBlockItemDtoToProductItem)}
          contentSource="other_user_items"
          itemTestId="owner-item"
        />
      )}
    </InView>
  )
}

export default ItemPageClosetPlugin
